import * as React from 'react';
import Image from 'components/Image';
import Webcam from 'components/Webcam';
import Button from 'components/Button';

import './styles/WebcamAvatarShooter.scss';

type Props = {
  onPictureTaken: (image?: string) => void;
};

type State = {
  picture?: string;
};

class WebcamAvatarShooter extends React.Component<Props, State> {
  state: State = {
    picture: undefined,
  };

  webcam: any;

  take = () => {
    if (this.webcam) {
      this.setState({ picture: this.webcam.snap() });
    }
  };

  retake = () => {
    this.setState({ picture: undefined });
  };

  continue = () => {
    this.props.onPictureTaken(this.state.picture);
  };

  renderPicture() {
    return (
      <div>
        <Image width={400} className="WebcamAvatarShooter--image" src={this.state.picture || ''} />
        <div className="WebcamAvatarShooter-buttons">
          <Button size="large" onClick={this.retake} level="secondary">
            Retake
          </Button>
          <Button size="large" onClick={this.continue} level="primary">
            Continue
          </Button>
        </div>
      </div>
    );
  }

  renderWebcam() {
    return (
      <div>
        <Webcam ref={(webcam: any) => (this.webcam = webcam)} height={300} width={400} />
        <div className="WebcamAvatarShooter-buttons">
          <Button size="large" full onClick={this.take}>
            Take picture
          </Button>
        </div>
      </div>
    );
  }

  render() {
    return <div>{this.state.picture ? this.renderPicture() : this.renderWebcam()}</div>;
  }
}

export default WebcamAvatarShooter;
